import { UserContext } from "@/context/User/UserContext";
import { getSingleReporter } from "@/services/Reporter.service";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import EditReporter from "../dialog/EditReporter";

const Reporter = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const reporter = useQuery({
		queryKey: ["reporter_" + id],
		queryFn: () => getSingleReporter(parseInt(id), user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});

	return (
		<>
			{reporter.isLoading ? (
				<div className="grid gap-4 pt-4">
					{Array.from({ length: 2 }).map((_, num) => (
						<div key={num} className="h-12 w-full bg-gray-200 animate-pulse" />
					))}
				</div>
			) : reporter.data ? (
				<>
					<div className="flex gap-3 items-end justify-between">
						<h1 className="font-medium text-4xl">
							Reporter: {reporter.data.reportername}
						</h1>
						<EditReporter user={user} reporter={reporter.data} />
					</div>
					<div className="border-y my-3 py-4 border-zinc-200">
						<div className="grid grid-cols-1 sm:grid-cols-2">
							<div className="flex gap-4">
								<div className="flex flex-col gap-2 text-zinc-500 font-light text-nowrap">
									<p>ID</p>
									<p>Name</p>
									<p>Designation</p>
								</div>
								<div className="flex flex-col gap-2">
									<p>{reporter.data.reporterid}</p>
									<p>{reporter.data.reportername}</p>
									<p>{reporter.data.designation}</p>
								</div>
							</div>
							<div className="flex gap-4">
								<div className="flex flex-col gap-2 text-zinc-500 font-light text-nowrap">
									<p>Created By</p>
									<p>Created At</p>
								</div>
								<div className="flex flex-col gap-2">
									<p>{reporter.data.createdbyname}</p>
									<p>{reporter.data.createdon}</p>
								</div>
							</div>
						</div>
					</div>
				</>
			) : null}
		</>
	);
};

export default Reporter;
